import React from "react";
import { useStateContext } from "../../context/ContextProvider";

const aboutContent = [
  {
    title: "Who We Are",
    content:
      "Do Deal Marketing Agency is a full-service marketing powerhouse that bridges the gap between technology, creativity, and strategy. With a dedicated team of experts, we deliver tailor-made marketing solutions that ensure measurable results and sustainable growth",
  },
  {
    title: "Our Mission",
    content:
      "At Do Deal Marketing Agency, we aim to empower businesses with cutting-edge tools and innovative marketing strategies to deliver world-class solutions. We believe in making excellence accessible and ensuring every project is delivered perfectly and on time",
  },
  {
    title: "Our Vision",
    content:
      "We aim to transform the marketing landscape by seamlessly blending technology, creativity, and strategy. By setting the gold standard for quality and innovation, we aspire to become the trusted partner for businesses worldwide",
  },
  // {
  //   title: "Our Values",
  //   content: "",
  //   bulletPoints: [
  //     "Innovation: Always ahead of the curve, we embrace the latest tools and trends.",
  //     "Excellence: Precision and quality in every project we undertake.",
  //     "Creativity: Out-of-the-box thinking to craft inspiring campaigns.",
  //     "Timeliness: Delivering on promises, always on schedule.",
  //     "Collaboration: Building strong partnerships with our clients.",
  //     "Integrity: Transparency and trust at the core of our processes.",
  //   ],
  // },
];

const AboutComponent = () => {
  const { isMobile } = useStateContext();
  return (
    <div className="w-full md:w-9/12 lg:w-1/2">
      {aboutContent?.map((about, index) => (
        <div className="" key={index}>
          <h1 className="subsubhero-text font-bold uppercase w-full">
            {about?.title}
          </h1>
          {about?.content && (
            <p className="text-[var(--l-gray)] text-justify text-sm my-5 w-9/12">
              {about?.content}
            </p>
          )}

          {about?.bulletPoints && (
            <ul className="list-disc pl-6 text-[var(--l-gray)] text-sm my-5 w-9/12">
              {about.bulletPoints.map((point, i) => {
                const [boldText, normalText] = point.split(":"); // Split at the first colon
                return (
                  <li key={i} className="mb-1">
                    <span className=" text-white">{boldText}:</span> {normalText}
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      ))}
    </div>
  );
};

export default AboutComponent;
